import parameterActionTypes from './parameterActionTypes';

export const getParameter = (request) => ({
  type: parameterActionTypes.GET_PARAMETERS_START,
  payload: request,
});

export const getParameterSuccess = (result) => ({
  type: parameterActionTypes.GET_PARAMETERS_SUCCESS,
  payload: result,
});

export const getParameterFailed = (error) => ({
  type: parameterActionTypes.GET_PARAMETERS_FAILED,
  payload: error,
});

export const getParameterSets = (request) => ({
  type: parameterActionTypes.GET_PARAMETERS_SET_START,
  payload: request,
});

export const getParameterSetsSuccess = (result) => ({
  type: parameterActionTypes.GET_PARAMETERS_SET_SUCCESS,
  payload: result,
});

export const getParameterSetsFailed = (error) => ({
  type: parameterActionTypes.GET_PARAMETERS_SET_FAILED,
  payload: error,
});

export const saveProductParameterValue = (request) => ({
  type: parameterActionTypes.SAVE_PARAMETER_START,
  payload: request,
});

export const saveProductParameterValueSuccess = (created) => ({
  type: parameterActionTypes.SAVE_PARAMETER_VALUE_SUCCESS,
  payload: created,
});

export const saveProductParameterValueFailed = (error) => ({
  type: parameterActionTypes.SAVE_PARAMETER_VALUE_FAILED,
  payload: error,
});

export const saveParameterSet = (request) => ({
  type: parameterActionTypes.SAVE_PARAMETER_SET_START,
  payload: request,
});

export const saveParameterSetSuccess = (body) => ({
  type: parameterActionTypes.SAVE_PARAMETER_SET_SUCCESS,
  payload: body,
});

export const saveParameterSetFailed = (error) => ({
  type: parameterActionTypes.SAVE_PARAMETER_SET_FAILED,
  payload: error,
});

export const deleteProductParameter = (id) => ({
  type: parameterActionTypes.DELETE_PARAMETER_VALUE_START,
  payload: id,
});

export const deleteProductParameterSuccess = (id) => ({
  type: parameterActionTypes.DELETE_PARAMETER_VALUE_SUCCESS,
  payload: id,
});

export const deleteProductParameterFailed = (error) => ({
  type: parameterActionTypes.DELETE_PARAMETER_VALUE_FAILED,
  payload: error,
});

export const deleteParameterSet = (id) => ({
  type: parameterActionTypes.DELETE_PARAMETER_SET_START,
  payload: id,
});

export const deleteParameterSetSuccess = (id) => ({
  type: parameterActionTypes.DELETE_PARAMETER_SET_SUCCESS,
  payload: id,
});

export const deleteParameterSetFailed = (error) => ({
  type: parameterActionTypes.DELETE_PARAMETER_SET_FAILED,
  payload: error,
});

export const saveProductParameterOptionsSuccess = (id) => ({
  type: parameterActionTypes.SAVE_PARAMETER_OPTION_SUCCESS,
  payload: id,
});

export const editOption = (data) => ({
  type: parameterActionTypes.UPDATE_PARAMETER_OPTIONS_STATE,
  payload: data,
});

export const removeOption = (id) => ({
  type: parameterActionTypes.REMOVE_PARAMETER_OPTION_FROM_STATE,
  payload: id,
});
